import moment from 'moment';

import { TransferOrderEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

import * as types from './types';

const INITIAL_STATE = {
  transferOrderListData: [],
  transferOrderListDataError: null,
  loading: false,
  printLoading: false,
  printLoadingError: null,
  fromDateMax: moment().add(1, 'month'),
  toDateMin: moment().subtract(1, 'month'),
  printData: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.TRANSFER_ORDER_LIST: {
      return {
        ...state,
        transferOrderListData: action.payload.map(item => ({
          ...item,
          [TransferOrderEnum.TransactionDT]: [TransferOrderEnum.TransactionDT]
            ? moment(item[TransferOrderEnum.TransactionDT]).format(
                DATE_FORMAT_FOR_UI
              )
            : '',
        })),
      };
    }

    case types.TRANSFER_ORDER_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.TRANSFER_ORDER_ERROR:
      return {
        ...state,
        transferOrderListData: action.payload,
      };

    case types.PRINT_PREVIEW_TRANSFER_LOADING:
      return {
        ...state,
        printLoading: action.payload,
      };

    case types.PRINT_PREVIEW_ERROR:
      return {
        ...state,
        printLoadingError: action.payload,
      };
    case types.CLEAR_TRANSFER_LIST_ERROR:
      return {
        ...state,
        printLoadingError: null,
        transferOrderListDataError: null,
      };
    case types.SET_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMax: action.payload,
      };
    case types.SET_TO_DATE_MIN:
      return {
        ...state,
        toDateMin: action.payload,
      };

    case types.SET_PRINT_DATA:
      return {
        ...state,
        printData: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/TransferOrderList/reducer.js